var vitalsStarted = false;

function ratingFor(name, value) {
  var thresholds = {
    LCP: [2500, 4000],
    INP: [200, 500],
    CLS: [0.1, 0.25]
  };
  var limits = thresholds[name];

  if (!limits || value <= limits[0]) {
    return 'good';
  }
  return value <= limits[1] ? 'needs-improvement' : 'poor';
}

function startWebVitals() {
  if (vitalsStarted || !window.PerformanceObserver) {
    return;
  }

  vitalsStarted = true;
  var metrics = { LCP: 0, INP: 0, CLS: 0 };
  var reported = false;

  function observe(type, callback, options) {
    try {
      var observer = new PerformanceObserver(function (list) {
        list.getEntries().forEach(callback);
      });
      observer.observe(options || { type: type, buffered: true });
    } catch (_error) {}
  }

  observe('largest-contentful-paint', function (entry) {
    metrics.LCP = entry.startTime;
  });

  observe('layout-shift', function (entry) {
    if (!entry.hadRecentInput) {
      metrics.CLS += entry.value;
    }
  });

  observe('event', function (entry) {
    if (entry.interactionId && entry.duration > metrics.INP) {
      metrics.INP = entry.duration;
    }
  }, { type: 'event', buffered: true, durationThreshold: 40 });

  function report() {
    if (reported || typeof window.gtag !== 'function') {
      return;
    }

    reported = true;
    var pageTemplate = document.body && document.body.dataset.pageTemplate;

    Object.keys(metrics).forEach(function (name) {
      var metricValue = metrics[name];
      if (!metricValue && name !== 'CLS') {
        return;
      }

      var roundedValue = Number(metricValue.toFixed(name === 'CLS' ? 3 : 0));

      window.gtag('event', 'web_vital_' + name.toLowerCase(), {
        value: name === 'CLS' ? Math.round(roundedValue * 1000) : roundedValue,
        metric_name: name,
        metric_value: roundedValue,
        metric_rating: ratingFor(name, metricValue),
        page_template: pageTemplate || 'unknown',
        non_interaction: true
      });
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      report();
    }
  }, { once: true });
  window.addEventListener('pagehide', report, { once: true });
}

document.addEventListener('turbolinks:load', startWebVitals);
